import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/api";

export default function WhatsAppFloat() {
  return (
    <a
      href={whatsappLink("Hi CompCar Motors! I'd like to chat about a vehicle.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat with CompCar Motors on WhatsApp"
      className="fixed bottom-6 right-6 z-[60] w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1fbe5b] text-white flex items-center justify-center shadow-2xl shadow-black/40 transition-all duration-300 hover:-translate-y-1 hover:scale-105"
    >
      <MessageCircle size={26} fill="currentColor" />
    </a>
  );
}
